
import * as THREE from 'three'
import PolyBool from '../../views/doodle3d/libs/polybooljs';
import ClipperLib from '../libs/clipper_unminified'

export function createPath(char, scale, offsetX, offsetY, data) {
    var glyph = data.glyphs[char] || data.glyphs['?'];

    if (!glyph) {

        console.error('THREE.Font: character "' + char + '" does not exists in font family ' + data.familyName + '.');

        return;

    }

    var centerX = offsetX + (glyph.x_min + glyph.x_max) * 0.5 * scale;
    var centerX2 = offsetX + glyph.ha * 0.5 * scale;
    offsetX += centerX2 - centerX;

    var path = new THREE.ShapePath();

    var x, y, cpx, cpy, cpx1, cpy1, cpx2, cpy2;

    if (glyph.o) {

        var outline = glyph._cachedOutline || (glyph._cachedOutline = glyph.o.split(' '));

        for (var i = 0, l = outline.length; i < l;) {

            var action = outline[i++];

            switch (action) {

                case 'm': // moveTo

                    x = outline[i++] * scale + offsetX;
                    y = outline[i++] * scale + offsetY;

                    path.moveTo(x, y);

                    break;

                case 'l': // lineTo

                    x = outline[i++] * scale + offsetX;
                    y = outline[i++] * scale + offsetY;

                    path.lineTo(x, y);

                    break;

                case 'q': // quadraticCurveTo

                    cpx = outline[i++] * scale + offsetX;
                    cpy = outline[i++] * scale + offsetY;
                    cpx1 = outline[i++] * scale + offsetX;
                    cpy1 = outline[i++] * scale + offsetY;

                    path.quadraticCurveTo(cpx1, cpy1, cpx, cpy);

                    break;

                case 'b': // bezierCurveTo

                    cpx = outline[i++] * scale + offsetX;
                    cpy = outline[i++] * scale + offsetY;
                    cpx1 = outline[i++] * scale + offsetX;
                    cpy1 = outline[i++] * scale + offsetY;
                    cpx2 = outline[i++] * scale + offsetX;
                    cpy2 = outline[i++] * scale + offsetY;

                    path.bezierCurveTo(cpx1, cpy1, cpx2, cpy2, cpx, cpy);

                    break;

            }

        }

    }

    return {
        offsetX: glyph.ha * scale,
        path: path
    };

}

const textDirection = {
    leftToRight: 1,
    rightToLeft: 2,
    topToBottom: 3,
    bottomToTop: 4,
};

export function makeGeom(vertices) {
    let geom = new THREE.BufferGeometry();
    geom.setAttribute("position", new THREE.BufferAttribute(new Float32Array(vertices), 3));
    geom.computeVertexNormals();
    return geom;
}

export function reverseFace(vertices, startIndex) {
    let tmp = 0;
    for (let i = startIndex; i < vertices.length; i += 9) {
        tmp = vertices[i + 3];
        vertices[i + 3] = vertices[i + 6];
        vertices[i + 6] = tmp;
        tmp = vertices[i + 4];
        vertices[i + 4] = vertices[i + 7];
        vertices[i + 7] = tmp;
        tmp = vertices[i + 5];
        vertices[i + 5] = vertices[i + 8];
        vertices[i + 8] = tmp;
    }
}


// 两个多边形之间的壁
function addBound(vertices, poly1, poly2) {
    let v2_1 = poly1[poly1.length - 1];
    let v2_2 = poly2[poly2.length - 1];
    for (let i = 0; i < poly1.length; i++) {
        let v1_1 = poly1[i];
        let v1_2 = poly2[i];
        addRect(vertices, v2_1, v1_1, v1_2, v2_2);

        v2_1 = v1_1;
        v2_2 = v1_2;
    }
}

// 将一个矩形转换为两个三角形
function addRect(vertices, a, b, c, d) {
    addTriangle(vertices, a, b, c);
    addTriangle(vertices, a, c, d);
}

// 将一个三角形加入顶点数组
function addTriangle(vertices, a, b, c) {
    vertices.push(a.x, a.y, a.z, b.x, b.y, b.z, c.x, c.y, c.z);
}

// vertices: 点的序列，非index
// shape: THREE shape
// m: 变换
// reverse: 面是否翻转方向。一个shape自身所构成的，实际上是底和顶。因此会频繁地需要翻转。上下、内部，所要求的的方向有所不同。
function addShape(vertices, {
    shape,
    curveSegments = 36,
    m = new THREE.Matrix4(), // 额外的变换
    reverse = false
}) {
    // 解算点列
    let shapePoints = shape.extractPoints(curveSegments).shape;
    // 三角化面
    const faces = THREE.ShapeUtils.triangulateShape(shapePoints.points, shapePoints.holes);

    let v = new THREE.Vector3();
    faces.forEach(f => {
        v.set(shapePoints.points[f[0]].x, shapePoints.points[f[0]].y, 0);
        v.applyMatrix4(m);
        vertices.push(v.x, v.y, v.z);
        if (reverse) {
            v.set(shapePoints.points[f[2]].x, shapePoints.points[f[2]].y, 0);
            v.applyMatrix4(m);
            v.set(shapePoints.points[f[1]].x, shapePoints.points[f[1]].y, 0);
            v.applyMatrix4(m);
        } else {
            v.set(shapePoints.points[f[1]].x, shapePoints.points[f[1]].y, 0);
            v.applyMatrix4(m);
            v.set(shapePoints.points[f[2]].x, shapePoints.points[f[2]].y, 0);
            v.applyMatrix4(m);
        }
    });
}

// 从shape构造一个柱体。
function addShapeExtrude(vertices, {
    shape,
    curveSegments = 36,
    m = false, // 额外的变换
    noTop = false, // 不要顶
    noBottom = false, // 不要底
    z1 = 0, // 下表面的z值
    z2 = 1, // 上表面的z值
}) {
    // 解算点列
    let shapePoints = shape.extractPoints(curveSegments);
    // 从点列构造柱体
    addShapePointsExtrude(vertices, {
        shapePoints,
        m,
        noTop,
        noBottom,
        z1,
        z2,
    })
}

// 从点列构造一个柱体
function addShapePointsExtrude(vertices, {
    shapePoints,
    m = false,
    noTop = false,
    noBottom = false,
    z1 = 0,
    z2 = 1,
}) {
    let begin = vertices.length;
    // 转换成3维的点列
    // shapePoints结构：{ shape, holes }
    let ps1 = shapePoints.shape.map(v => new THREE.Vector3(v.x, v.y, z1)); // 上面一圈
    let ps2 = shapePoints.shape.map(v => new THREE.Vector3(v.x, v.y, z2)); // 下面一圈
    addBound(vertices, ps1, ps2); // 构造一个壁
    // 对于孔洞，需要构造一个内部的壁
    for (let i = 0; i < shapePoints.holes.length; i++) {
        // 方法一样。有多少个孔洞，就构造多少个壁
        let ps1 = shapePoints.holes[i].map(v => new THREE.Vector3(v.x, v.y, z1));
        let ps2 = shapePoints.holes[i].map(v => new THREE.Vector3(v.x, v.y, z2));
        addBound(vertices, ps1, ps2);
    }

    if (!noTop || !noBottom) {
        // 封闭上下面
        // 对点列进行三角化
        const faces = THREE.ShapeUtils.triangulateShape(shapePoints.shape, shapePoints.holes);
        // console.log("faces", faces);
        if (!noTop) {
            faces.forEach(f => {
                vertices.push(points[f[0]].x, points[f[0]].y, z1);
                vertices.push(points[f[2]].x, points[f[2]].y, z1);
                vertices.push(points[f[1]].x, points[f[1]].y, z1);
            });
        }

        if (!noBottom) {
            faces.forEach(f => {
                vertices.push(points[f[0]].x, points[f[0]].y, z2);
                vertices.push(points[f[1]].x, points[f[1]].y, z2);
                vertices.push(points[f[2]].x, points[f[2]].y, z2);
            });
        }
    }

    if (m) {
        let v = new THREE.Vector3();
        for (let i = begin; i < vertices.length; i += 3) {
            v.set(vertices[i], vertices[i + 1], vertices[i + 2]);
            v.applyMatrix4(m);
        }
    }
}


// 构造柱体：薄壳。
export function addShapeExtrudeShell(vertices, {
    shape,
    curveSegments = 36,
    z1 = 0,
    z2 = 1,
    t = 0.1, // 厚度
}) {
    // 解算点列
    let shapePoints = shape.extractPoints(curveSegments);
    // 计算平行的多边形
    
    let rawCubiclePoly = cubicleMaker[box.cubicle - 1](box);
    let cubiclePoly = PolyBool.intersect(innerPoly, rawCubiclePoly);
    let cubicleVertexes = cubiclePoly.regions[0].map(p => ({ x: p[0], y: p[1] }));
    let cubicleShape = makeShape(cubicleVertexes);

    let ps1 = shapePoints.shape.map(v => new THREE.Vector3(v.x, v.y, z1));
    let ps2 = shapePoints.shape.map(v => new THREE.Vector3(v.x, v.y, z2));
    addBound(vertices, ps2, ps1); // 外侧壁
    // 这里，内外壁的次序是一样的，说明内部是顺时针的。
    for (let i = 0; i < shapePoints.holes.length; i++) {
        let ps1 = shapePoints.holes[i].map(v => new THREE.Vector3(v.x, v.y, z1));
        let ps2 = shapePoints.holes[i].map(v => new THREE.Vector3(v.x, v.y, z2));
        addBound(vertices, ps2, ps1); // 内侧壁
    }
    // 下表面
    const faces = THREE.ShapeUtils.triangulateShape(shapePoints.shape, shapePoints.holes);
    let points = [].concat(shapePoints.shape);
    for (let i = 0; i < shapePoints.holes.length; i++) {
        points = points.concat(shapePoints.holes[i]);
    }
    // console.log("faces", faces);
    faces.forEach(f => {
        vertices.push(points[f[0]].x, points[f[0]].y, z1);
        vertices.push(points[f[2]].x, points[f[2]].y, z1);
        vertices.push(points[f[1]].x, points[f[1]].y, z1);
    });
    // 上表面
    faces.forEach(f => {
        vertices.push(points[f[0]].x, points[f[0]].y, z2);
        vertices.push(points[f[1]].x, points[f[1]].y, z2);
        vertices.push(points[f[2]].x, points[f[2]].y, z2);
    });
}

// 构造柱体1：普通。
export function addShapeExtrude1(vertices, {
    shape,
    curveSegments = 36,
    z1 = 0,
    z2 = 1,
}) {
    let shapePoints = shape.extractPoints(curveSegments);
    let ps1 = shapePoints.shape.map(v => new THREE.Vector3(v.x, v.y, z1));
    let ps2 = shapePoints.shape.map(v => new THREE.Vector3(v.x, v.y, z2));
    addBound(vertices, ps2, ps1); // 外侧壁
    // 这里，内外壁的次序是一样的，说明内部是顺时针的。
    for (let i = 0; i < shapePoints.holes.length; i++) {
        let ps1 = shapePoints.holes[i].map(v => new THREE.Vector3(v.x, v.y, z1));
        let ps2 = shapePoints.holes[i].map(v => new THREE.Vector3(v.x, v.y, z2));
        addBound(vertices, ps2, ps1); // 内侧壁
    }
    // 下表面
    const faces = THREE.ShapeUtils.triangulateShape(shapePoints.shape, shapePoints.holes);
    let points = [].concat(shapePoints.shape);
    for (let i = 0; i < shapePoints.holes.length; i++) {
        points = points.concat(shapePoints.holes[i]);
    }
    // console.log("faces", faces);
    faces.forEach(f => {
        vertices.push(points[f[0]].x, points[f[0]].y, z1);
        vertices.push(points[f[2]].x, points[f[2]].y, z1);
        vertices.push(points[f[1]].x, points[f[1]].y, z1);
    });
    // 上表面
    faces.forEach(f => {
        vertices.push(points[f[0]].x, points[f[0]].y, z2);
        vertices.push(points[f[1]].x, points[f[1]].y, z2);
        vertices.push(points[f[2]].x, points[f[2]].y, z2);
    });
}

// 上下只保留一面
export function addShapeExtrude3(vertices, {
    shape,
    curveSegments = 36,
    z1 = 0,
    z2 = 1,
    keepTop = true,
    keepBottom = true,
}) {
    let shapePoints = shape.extractPoints(curveSegments);
    let ps1 = shapePoints.shape.map(v => new THREE.Vector3(v.x, v.y, z1));
    let ps2 = shapePoints.shape.map(v => new THREE.Vector3(v.x, v.y, z2));
    addBound(vertices, ps1, ps2); // 外侧壁
    for (let i = 0; i < shapePoints.holes.length; i++) {
        let ps1 = shapePoints.holes[i].map(v => new THREE.Vector3(v.x, v.y, z1));
        let ps2 = shapePoints.holes[i].map(v => new THREE.Vector3(v.x, v.y, z2));
        addBound(vertices, ps2, ps1); // 内侧壁
    }
    if (keepTop || keepBottom) {
        const faces = THREE.ShapeUtils.triangulateShape(shapePoints.shape, shapePoints.holes);
        let points = [].concat(shapePoints.shape);
        for (let i = 0; i < shapePoints.holes.length; i++) {
            points = points.concat(shapePoints.holes[i]);
        }
        // 下表面
        if (keepBottom) {
            faces.forEach(f => {
                vertices.push(points[f[0]].x, points[f[0]].y, z1);
                vertices.push(points[f[2]].x, points[f[2]].y, z1);
                vertices.push(points[f[1]].x, points[f[1]].y, z1);
            });
        }
        // 上表面
        if (keepTop) {
            faces.forEach(f => {
                vertices.push(points[f[0]].x, points[f[0]].y, z2);
                vertices.push(points[f[1]].x, points[f[1]].y, z2);
                vertices.push(points[f[2]].x, points[f[2]].y, z2);
            });
        }
    }
}

// 如果一个形状有孔洞，那么孔洞不是穿透整个柱体，而是只挖穿一半。
export function addShapeExtrude2(vertices, {
    shape,
    curveSegments = 36,
    z1 = 0,
    z2 = 1,
    z3 = 0.8
}) {
    // console.log(z1, z2, z3);
    // 构造垂直壁
    let shapePoints = shape.extractPoints(curveSegments);
    let ps1 = shapePoints.shape.map(v => new THREE.Vector3(v.x, v.y, z1));
    let ps2 = shapePoints.shape.map(v => new THREE.Vector3(v.x, v.y, z2));
    addBound(vertices, ps1, ps2); // 外侧壁
    for (let i = 0; i < shapePoints.holes.length; i++) {
        let ps1 = shapePoints.holes[i].map(v => new THREE.Vector3(v.x, v.y, z3));
        let ps2 = shapePoints.holes[i].map(v => new THREE.Vector3(v.x, v.y, z2));
        addBound(vertices, ps2, ps1); // 内侧壁：短，从顶部开始，但是并没有触到底部，是悬空的。
    }
    // 下表面：没有孔洞
    const faces = THREE.ShapeUtils.triangulateShape(shapePoints.shape, []);
    // console.log("faces", faces);
    faces.forEach(f => {
        vertices.push(shapePoints.shape[f[0]].x, shapePoints.shape[f[0]].y, z1);
        vertices.push(shapePoints.shape[f[2]].x, shapePoints.shape[f[2]].y, z1);
        vertices.push(shapePoints.shape[f[1]].x, shapePoints.shape[f[1]].y, z1);
    });

    // console.log('shapePoints', shapePoints);
    // 上表面：有孔洞
    const faces2 = THREE.ShapeUtils.triangulateShape(shapePoints.shape, shapePoints.holes);
    let points = [].concat(shapePoints.shape);
    for (let i = 0; i < shapePoints.holes.length; i++) {
        points = points.concat(shapePoints.holes[i]);
    }
    // console.log('points', points);
    // console.log("faces", faces);
    faces2.forEach(f => {
        vertices.push(points[f[0]].x, points[f[0]].y, z2);
        vertices.push(points[f[1]].x, points[f[1]].y, z2);
        vertices.push(points[f[2]].x, points[f[2]].y, z2);
    });
    // 中间面：从内部壁的悬空处开始，把空洞填补起来
    for (let i = 0; i < shapePoints.holes.length; i++) {
        let hole = shapePoints.holes[i];
        const faces3 = THREE.ShapeUtils.triangulateShape(hole, []);
        
        faces3.forEach(f => {
            vertices.push(hole[f[0]].x, hole[f[0]].y, z3);
            vertices.push(hole[f[1]].x, hole[f[1]].y, z3);
            vertices.push(hole[f[2]].x, hole[f[2]].y, z3);
        });
    }
}

function vector2ToFPoint(p) {
    return new ClipperLib.FPoint(p.x, p.y);
}

function contourContainsHole(contour, hole) {
    let contourPath = [contour.map(vector2ToFPoint)];
    let holePath = [hole.map(vector2ToFPoint)];
    let inter = new ClipperLib.Paths();
    let c = new ClipperLib.Clipper();
    c.AddPaths(contourPath, ClipperLib.PolyType.ptSubject, true);
    c.AddPaths(holePath, ClipperLib.PolyType.ptClip, true);
    c.Execute(ClipperLib.ClipType.ctIntersection, inter);
    // console.log('inter 2', inter);
    return inter.length > 0;
}

// 如果一个形状有孔洞，那么孔洞不是穿透整个柱体，而是只挖穿一半。
// 点列的版本
export function addShapeExtrude2_2(vertices, {
    contour,
    holes,
    innerPaths,
    z1 = 0,
    z2 = 1,
    z3 = 0.9
}) {
    // A表面：外侧与内侧
    // 注意，这个函数会改变contour和holes。有可能删除结尾的一个点
    const facesA = THREE.ShapeUtils.triangulateShape(contour, holes);
    let pointsA = [].concat(contour);
    for (let i = 0; i < holes.length; i++) {
        pointsA = pointsA.concat(holes[i]);
    }
    facesA.forEach(f => {
        vertices.push(pointsA[f[0]].x, pointsA[f[0]].y, z2);
        vertices.push(pointsA[f[1]].x, pointsA[f[1]].y, z2);
        vertices.push(pointsA[f[2]].x, pointsA[f[2]].y, z2);
    });
    // B表面：夹缝孔，挨个三角化
    for (let path of innerPaths) {
        const facesB = THREE.ShapeUtils.triangulateShape(path.shape, path.holes);
        let pointsB = [].concat(path.shape);
        for (let i = 0; i < path.holes.length; i++) {
            pointsB = pointsB.concat(path.holes[i]);
        }
        facesB.forEach(f => {
            vertices.push(pointsB[f[0]].x, pointsB[f[0]].y, z3);
            vertices.push(pointsB[f[2]].x, pointsB[f[2]].y, z3);
            vertices.push(pointsB[f[1]].x, pointsB[f[1]].y, z3);
        });
    }
    // 外 - 夹缝外
    let innerPathShapes = innerPaths.map(inner => inner.shape);
    let containFlags = holes.map(hole => innerPathShapes.some(shape => contourContainsHole(shape, hole)));
    let innerHoles = holes.filter((_, index) => !containFlags[index]);
    let innerContours = [
        ...innerPathShapes,
        ...innerHoles
    ]; // ...holes
    const facesC = THREE.ShapeUtils.triangulateShape(contour, innerContours);
    let pointsC = [].concat(contour);
    for (let i = 0; i < innerContours.length; i++) {
        pointsC = pointsC.concat(innerContours[i]);
    }
    facesC.forEach(f => {
        vertices.push(pointsC[f[0]].x, pointsC[f[0]].y, z1);
        vertices.push(pointsC[f[2]].x, pointsC[f[2]].y, z1);
        vertices.push(pointsC[f[1]].x, pointsC[f[1]].y, z1);
    });
    // 夹缝内 - 内
    let leftHoles = holes.filter((_, index) => containFlags[index]);
    innerPaths.forEach(inner => {
        inner.holes.forEach(innerHole => {
            let index = leftHoles.findIndex(hole => contourContainsHole(innerHole, hole));
            if (index < 0) {
                console.error("error shape");
                return;
            }
            let hole = leftHoles[index];
            const facesD = THREE.ShapeUtils.triangulateShape(innerHole, [hole]);
            let pointsD = [...innerHole, ...hole];
            facesD.forEach(f => {
                vertices.push(pointsD[f[0]].x, pointsD[f[0]].y, z1);
                vertices.push(pointsD[f[2]].x, pointsD[f[2]].y, z1);
                vertices.push(pointsD[f[1]].x, pointsD[f[1]].y, z1);
            });
            leftHoles.splice(index, 1);
        });
    });

    // 构造垂直壁
    // 外侧壁
    let ps1 = contour.map(v => new THREE.Vector3(v.x, v.y, z1));
    let ps2 = contour.map(v => new THREE.Vector3(v.x, v.y, z2));
    addBound(vertices, ps2, ps1);
    // 内孔壁
    for (let i = 0; i < holes.length; i++) {
        let ps1 = holes[i].map(v => new THREE.Vector3(v.x, v.y, z1));
        let ps2 = holes[i].map(v => new THREE.Vector3(v.x, v.y, z2));
        addBound(vertices, ps2, ps1);
    }
    // 夹缝
    for (let path of innerPaths) {
        addBound(vertices, path.shape.map(v => new THREE.Vector3(v.x, v.y, z3)), path.shape.map(v => new THREE.Vector3(v.x, v.y, z1)));
        // 夹缝壁
        for (let i = 0; i < path.holes.length; i++) {
            let ps1 = path.holes[i].map(v => new THREE.Vector3(v.x, v.y, z3));
            let ps2 = path.holes[i].map(v => new THREE.Vector3(v.x, v.y, z1));
            addBound(vertices, ps1, ps2);
        }
    }
}




// WEBPACK FOOTER //
// ./src/3dapps/smallSoftware/modeller.js